import type { PropsWithChildren } from 'react';
import { cn } from '../../utils/cn';
import clsx from 'clsx';
import { useCreditCard } from './CreditCard';
import { Icon } from '../Icon';

type CreditCardCvvProps = PropsWithChildren & {
  className?: string;
};

export const CreditCardCvv = ( { children, className }: CreditCardCvvProps ) => {
  const creditCard = useCreditCard();

  return (
    <div className={ cn( 'text-white [text-shadow:_0_2px_2px_rgba(0,0,0,0.4)] tabular-nums', className ) }>
      <div className={ clsx(
        {
          'text-xs': creditCard.size === 'default',
          'text-[6px]': creditCard.size === 'sm'
        }
      ) }>CVV</div>
      <div
        className={ clsx(
          {
            'group hover:text-white/80 cursor-pointer flex flex-row items-center gap-2.5': creditCard.enableCopy,
            'text-base': creditCard.size === 'default',
            'text-[8px]': creditCard.size === 'sm'
          }
        ) }
        onClick={ creditCard.enableCopy ? () => {
          if ( typeof children === 'string' ) {
            creditCard.copyText( children )
          }
        } : undefined }
      >
        {children}
        {creditCard.enableCopy && (
          <Icon
            name={ 'file-copy' }
            className={ clsx(
              'text-lg transition-opacity duration-200',
              {
                'opacity-0 group-hover:opacity-80': creditCard.enableCopy
              }
            ) }
          />
        )}
      </div>
    </div>
  )
}
CreditCardCvv.displayName = 'CreditCardCvv';
